import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { CibusStatusActionRequest, OrderView } from 'shared-models/browser';

export type { CibusStatusAction, CibusStatusActionRequest } from 'shared-models/browser';

class PosCibusService {
  // POS lifecycle action (accept / reject / sent); the backend pushes to Cibus first.
  async applyStatus(
    tenantId: string,
    employeeSession: string,
    orderId: number,
    payload: CibusStatusActionRequest,
  ): Promise<OrderView> {
    try {
      const response = await authenticatedInstance.post<OrderView>(
        `/cibus/tenant/${tenantId}/orders/${orderId}/status`,
        payload,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון ההזמנה בסיבוס נכשל'));
    }
  }
}

export const posCibusService = new PosCibusService();
